import React from 'react';
import Messenger from '../Messenger/Messenger';

const ChatPage = () => {
    return (
        <div className='scrool'>
            <Messenger />
        </div>
    );
};

export default ChatPage;